module.exports = __webpack_public_path__ + "static/Group 2-b3c155f1024fcf87a552dc091d10a37f.png";